<div>
	<app-create-company-side-form
		label="Add a mortgage brokerage"
		[minify]="false"
		(onSubmit)="onSubmit($event)"
		(onCancel)="onCancel()"
		[name]="name"
		[company]="brokerage"
	>
	</app-create-company-side-form>
</div>
